import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { inject } from '@vercel/analytics'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './styles/global.css'

Vue.config.productionTip = false

// The @vercel/analytics/vue component needs Vue 3, so use the framework-agnostic
// script; it tracks vue-router (history mode) navigations through pushState.
inject()

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
